<template>
  <v-select
    :label="label"
    :items="items"
    item-text="description"
    :item-value="itemValue"
    return-object
    solo
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content class="font-weight-bold text--secondary" v-if="item.isMainCategory">
        <v-list-item-title>
          {{ item.description }}
        </v-list-item-title>
      </v-list-item-content>

      <v-list-item-content v-if="!item.isMainCategory">
        <v-list-item-title>{{ item.id ? ' - ' : '' }}{{ item.description }} </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>

export default {
  props: {
    value: Object,
    label: String,
    items: Array,
    itemValue: { type: String, default: 'itemId' },
  },
};
</script>
